import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { getUserInfo, isNotLogin, UserData } from "../fetch";

export function useFirstTimeRender() {
  const isFirstTimeRender = useRef(true)
  useLayoutEffect(() => {
    return () => {
      isFirstTimeRender.current = false
    }
  })
  return isFirstTimeRender
}


export function useStillAlive() {
  const isAlive = useRef(true)
  useLayoutEffect(() => {
    return () => {
      isAlive.current = false
    }
  }, [])
  return () => {
    return isAlive.current
  }
}

export function useUser() {
  const [userInfo, setUserInfo] = useState<UserData | null | undefined>()
  useEffect(() => {
    const user = getUserInfo()
    user.then(ret => {
      setUserInfo(ret)
    }, (err) => {
      if (isNotLogin(err)) {
        setUserInfo(null)
      }
    })
  }, [])
  return userInfo
}


export function useSeqReq<T extends Promise<any>, A extends any[]>(fetcher: (...args: A) => T): (...args: A) => T {
  let _inst: any

  return useCallback((...args: A) => {
    if (_inst != null) {
      return Promise.reject(new Error()) as T
    }
    const inst = fetcher(...args)
    _inst = inst
    inst.then(() => {
      _inst = undefined
    }, () => {
      _inst = undefined
    })
    return inst
  }, [fetcher])
}



export function useDebouncing<T extends (...args: any) => any>(fn: T, delay: number | undefined, deps: ReadonlyArray<any>) {

  const timmerId = useRef<number>()
  const debFn = useMemo(() => {
    return (...args: Parameters<T>) => {
      clearTimeout(timmerId.current)
      timmerId.current = setTimeout(() => {
        fn(...args)
      }, delay) as any as number
    }
  }, [fn, delay].concat(deps))
  return debFn
}

